const FormResources = {

    form_data:{
        full_name: '',
        role_id:                    [],
        permissions_template_id:    [],
        reports_to:                 [],
        country_id:                 [],
        position_id:                [],
        shift_id:                   [],
        department_id:              [],
        contact_type_id:            [],
        status_id:                  [],
        include_in_supervisor_lists: []
    },

    statuses:
    [
        {
            id: 1, 
            name: 'Active'
        },
        {
            id: 0, 
            name: 'Inactive'
        }
    ],

    include_in_supervisor_lists:
    [
        {
            id: 1, 
            name: 'Yes'
        },
        {
            id: 0, 
            name: 'No'
        }
    ],

    shifts:
    [
        {
            id: 1, 
            name: 'Day'
        },
        {
            id: 2, 
            name: 'Evening'
        },
        {
            id: 3, 
            name: 'Night'
        }
    ]

}

export default FormResources